import * as React from "react";
import i18n from "i18next";
import { PartParamType } from "../../api/GrammarApi";
import { LabelPartParam } from "../../api/LabelizeApi";
import Autocomplete from "../../component/autocomplete/Autocomplete";
import StateDropdown from "../../component/observation/StateDropdown";
import MessageService from "../../service/MessageService";

interface PartParamProps {
  partParam: LabelPartParam;
  partParamType: PartParamType;

  onValueChange(partParam: LabelPartParam): void;

  prefValues: string[];
}

export default class PartParam extends React.Component<PartParamProps> {
  private getSelected(props: PartParamProps): any {
    if (props.partParam?.value && props.partParamType?.options) {
      return props.partParamType.options.find((item) => item.code === props.partParam.value);
    }
  }

  private onChangeValue(selected: any) {
    if (selected) {
      this.props.partParam.value = selected.code;
      if (this.props.partParam.state === "proposal") {
        this.props.partParam.state = "validated";
      }
    } else {
      MessageService.error(i18n.t("labelize.selectValue"));
      return;
    }

    this.forceUpdate();

    this.props.onValueChange(this.props.partParam);
  }

  private onChangeState(state: string) {
    if (state === "proposal") {
      MessageService.error(i18n.t("labelize.invalidStateParam"));
      return;
    }
    this.props.partParam.state = state;
    this.forceUpdate();
  }

  render() {
    return (
      <div className="part-param">
        <div className="input-group">
          <Autocomplete
            onChange={this.onChangeValue.bind(this)}
            placeholder={this.props.partParam.type}
            items={this.props.partParamType ? this.props.partParamType.options : []}
            toLabel={(item) => item.code}
            value={this.getSelected(this.props)}
          />

          {this.props.partParam.state !== "proposal" && (
            <StateDropdown state={this.props.partParam.state} onChange={this.onChangeState.bind(this)} />
          )}
        </div>

        {this.renderPrefValues()}
      </div>
    );
  }

  private renderPrefValues(): JSX.Element {
    return (
      <div className="row mt-1">
        {this.props.prefValues &&
          this.props.prefValues.map((vPref) => {
            return (
              <span
                key={"pref-value-" + vPref}
                className="badge badge-light cursor-pointer col-auto"
                onClick={() => this.onChangeValue({ code: vPref })}
              >
                {vPref}
              </span>
            );
          })}
      </div>
    );
  }
}
